import DynamicCardFeed from '../scripts/sections/DynamicCardFeed';
import DynamicFeaturedStores from '../scripts/sections/DynamicFeaturedStores';
import DynamicFutureEvents from '../scripts/sections/DynamicFutureEvents';
import DynamicGallery from '../scripts/sections/DynamicGallery';
import DynamicMediaSlider from '../scripts/sections/DynamicMediaSlider';
import DynamicPastEvents from '../scripts/sections/DynamicPastEvents';
import DynamicProductFeed from '../scripts/sections/DynamicProductFeed';
import DynamicSizeGuide from '../scripts/sections/DynamicSizeGuide';
import DynamicSlideshow from '../scripts/sections/DynamicSlideshow';
import DynamicStyleGuide from '../scripts/sections/DynamicStyleGuide';
import DynamicTestimonials from '../scripts/sections/DynamicTestimonials';

// Sections
import MainBlog from '../scripts/sections/MainBlog';
import MainCart from '../scripts/sections/MainCart';
import MainCollection from '../scripts/sections/MainCollection';
import MainCollectionBanner from '../scripts/sections/MainCollectionBanner';
import MainHeader from '../scripts/sections/MainHeader';
import MainMinicart from '../scripts/sections/MainMinicart';
import MainProduct from '../scripts/sections/MainProduct';
import Sections from '../scripts/helpers/SectionManager';

import initAOS from '../scripts/global/initAos';
import initModals from '../scripts/global/initModals';
import initShowcase from '../scripts/global/initShowcase';
import initVideos from '../scripts/global/initVideos';

// Init global sections
const sections = new Sections();
sections.register('main-product', section => new MainProduct(section));
sections.register(
  'main-collection-grid',
  section => new MainCollection(section),
);
sections.register(
  'main-collection-banner',
  section => new MainCollectionBanner(section),
);
sections.register('main-header', section => new MainHeader(section));
sections.register('main-blog', section => new MainBlog(section));
sections.register('main-minicart', section => new MainMinicart(section));
sections.register('main-cart', section => new MainCart(section));
sections.register('main-search', section => new MainCollection(section));

sections.register(
  'dynamic-card-feed',
  section => new DynamicCardFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-featured-stores',
  section => new DynamicFeaturedStores(section),
  { lazy: true },
);
sections.register(
  'dynamic-future-events',
  section => new DynamicFutureEvents(section),
  { lazy: true },
);
sections.register(
  'dynamic-gallery',
  section => new DynamicGallery(section),
  { lazy: true },
);
sections.register(
  'dynamic-past-events',
  section => new DynamicPastEvents(section),
  { lazy: true },
);
sections.register(
  'dynamic-product-feed',
  section => new DynamicProductFeed(section),
  { lazy: true },
);
sections.register(
  'dynamic-slideshow',
  section => new DynamicSlideshow(section),
  { lazy: true },
);
sections.register(
  'dynamic-media-slider',
  section => new DynamicMediaSlider(section),
  { lazy: true },
);
sections.register(
  'dynamic-size-guide',
  section => new DynamicSizeGuide(section),
  { lazy: true },
);
sections.register(
  'dynamic-fit-images',
  section => new DynamicSizeGuide(section),
  { lazy: true },
);
sections.register(
  'dynamic-style-guide',
  section => new DynamicStyleGuide(section),
  { lazy: true },
);
sections.register(
  'dynamic-testimonials',
  section => new DynamicTestimonials(section),
  { lazy: true },
);

initAOS();
initVideos();
initModals();
initShowcase();
